import data from "../../shared/sharedData";

export default {
  name: "Employment Point of Contact Information",
  pageInfo: {
    text: "The information contained in this Section must be that of an employee of the employer who is authorized to act on behalf of the employer in labor certification matters. The information in this Section <u>must be different</u> from the agent or attorney information listed in Section E, unless the attorney is an employee of the employer.",
    coloring: "grey",
  },
  sections: [
    {
      name: "Employer Name(s)",
      fields: [
        {
          widget: "inlinePrefiller",
          prefillLabel:
            "Select an Employer Point of Contact profile to populate this section (optional)",
          code: "D",
          prefill: {
            schema: "employerPocs",
            type: "employer-pocs",
            formName: "9035",
            formSection: "D",
          },
        },
        {
          code: "D.1",
          machine_name: "d1_poc_last",
          widget: "text",
          label: "Contact's Last (family) Name",
          validate: [
            "required",
            {
              minLength: 2,
              message:
                "Contact's full Last Name must contain at least 2 characters.",
            },
          ],
          maxLength: 35,
          tooltip:
            "Enter the last (family) name of the employer’s point of contact.",
        },
        {
          code: "D.2",
          machine_name: "d2_poc_first",
          widget: "text",
          label: "First (given) Name",
          validate: [
            "required",
            {
              minLength: 2,
              message:
                "Contact's full First Name must contain at least 2 characters.",
            },
          ],
          maxLength: 35,
          tooltip:
            "Enter the first (given) name of the employer’s point of contact.",
        },
        {
          code: "D.3",
          machine_name: "d3_poc_middle",
          widget: "text",
          label: "Middle name(s)",
          maxLength: 35,
          tooltip:
            "Enter the middle name of the employer’s point of contact, if applicable. Enter “N/A” if not applicable.",
        },
        {
          code: "D.4",
          machine_name: "d4_poc_title",
          widget: "text",
          label: "Contact's Job Title",
          validate: [
            "required",
            {
              minLength: 5,
              message:
                "Contact's full Job Title must contain at least 5 characters.",
            },
          ],
          maxLength: 60,
          tooltip: "Enter the job title of the employer's point of contact.",
        },
      ],
    },
    {
      fields: [
        {
          code: "D.5",
          machine_name: "d5_poc_address_1",
          widget: "text",
          label: "Address 1",
          validate: [
            "required",
            {
              minLength: 5,
              message: "Address 1 must contain at least 5 characters.",
            },
          ],
          maxLength: 60,
          tooltip:
            "Enter the business street address of the employer’s point of contact.",
        },
        {
          code: "D.6",
          machine_name: "d6_poc_address_2",
          widget: "text",
          label:
            "<span>Address 2 <i>(apartment/suite/floor and number)</i></span>",
          maxLength: 60,
          tooltip:
            "If additional space is needed for the street address, use this line to complete the street address. If no additional space is needed, enter “N/A.”",
        },
        {
          code: "D.10",
          machine_name: "d10_poc_country_id",
          widget: "select",
          label: "Country",
          selection: data.country,
          validate: ["required"],
          clearSchema: ["d8_poc_state_id", "d11_poc_province"],
          tooltip:
            "Enter the country of the employer's point of contact. If the city and country are the same, the name must still be entered in both fields.",
        },
        {
          code: "D.7",
          machine_name: "d7_poc_city",
          widget: "text",
          label: "City",
          validate: [
            "required",
            {
              minLength: 2,
              message: "City must contain at least 2 characters.",
            },
          ],
          maxLength: 35,
          disabled: true,
          disableWhenField: "d10_poc_country_id",
          tooltip:
            "Enter the city of the employer's point of contact.  If the city and country are the same, the name must still be entered in both fields.",
        },
        {
          code: "D.8",
          machine_name: "d8_poc_state_id",
          widget: "select",
          label: "State",
          selection: data.state,
          disabled: true,
          disableWhenField: "d10_poc_country_id",
          state: true,
          isVisible: {
            when: "d10_poc_country_id",
            is: ["UNITED STATES OF AMERICA", "- Select -", ""],
            operator: "||",
            hideStyles: true,
          },
          validate: ["required"],
          tooltip:
            "Enter the State, District, or Territory of the employer's point of contact.",
        },
        {
          code: "D.11",
          machine_name: "d11_poc_province",
          widget: "text",
          label: "Province",
          maxLength: 25,
          validate: [
            {
              isRequired: "d10_poc_country_id",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "CANADA",
              },
            },
            {
              minLength: 5,
              message: "Province must contain at least 5 characters.",
            },
          ],
          isVisible: {
            when: "d10_poc_country_id",
            is: ["UNITED STATES OF AMERICA", "- Select -", ""],
            operator: "!==",
            hideStyles: true,
          },
          tooltip:
            "Enter the province of the employer's point of contact, if applicable. Enter “N/A” if not applicable.",
        },
        {
          code: "D.9",
          machine_name: "d9_poc_zip",
          widget: "text",
          label: "Postal Code",
          validate: [
            "required",
            {
              postalCountry: "d10_poc_country_id",
              needsFieldValues: true,
              extraData: {
                valueOf: "d10_poc_country_id",
              },
            },
          ],
          disabled: true,
          disableWhenField: "d10_poc_country_id",
          maxLength: 10,
          tooltip:
            "Enter the postal (zip) code of the employer's point of contact.",
        },
      ],
    },
    {
      fields: [
        {
          code: "D.12",
          machine_name: "d12_poc_phone",
          widget: "phone",
          label: "Telephone Number",
          validate: ["required", "phone"],
          tooltip:
            "Enter the area code and business telephone number of the employer's point of contact.  Include country code, ifthe point of contact is located outside the United States.",
        },
        {
          code: "D.13",
          machine_name: "d13_poc_phone_ext",
          widget: "text",
          label: "Extension",
          validate: ["number"],
          parse: "positiveWholeNumber", //don't allow decimal Number and negative number // not working for me? -NG
          maxLength: 4,
          tooltip:
            "Enter the extension of the telephone number of the employer's point of contact, if applicable. Enter “N/A” if not applicable.",
        },
        {
          code: "D.14",
          machine_name: "d14_poc_email",
          widget: "text",
          label: "Business e-mail address",
          validate: [
            "required",
            {
              email: {
                extraData: {
                  allowNAs: true,
                },
              },
            },
          ],
          maxLength: 55,
          tooltip:
            "Enter the business email address of the employer's point of contact in the format name@emailaddress.top-leveldomain. The email entered in this field must be the same as the one regularly used by the employer’s point of contact for its business operations and capable of sending and receiving electronic communications from the Department with respect to the processing of this application. If the employer’s point of contact does not possess a business email address, please enter “N/A.”",
        },
      ],
    },
  ],
};
